"use client";

import { Stack, Box } from "@mui/material";
import rawAnimation from "@/assets/animations/animation.json";
import { stripLottieWatermark } from "@/types/lottie";

import dynamic from "next/dynamic";
const Lottie = dynamic(() => import("lottie-react"), { ssr: false, loading: () => null });

const cleanedAnimation = stripLottieWatermark(rawAnimation);

type ResponsivePadding =
  | number
  | { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };

type HeroAnimationProps = {
  frameHeight?: number;
  framePadding?: ResponsivePadding;
  artScale?: number;
  align?: "left" | "center" | "right";
};

export default function HeroAnimation({
  frameHeight = 220,
  framePadding = { xs: 0, md: 16, lg: 24 },
  artScale = 1,
  align = "center",
}: HeroAnimationProps) {
  const ar =
    typeof cleanedAnimation.w === "number" &&
      typeof cleanedAnimation.h === "number" &&
      cleanedAnimation.h > 0
      ? cleanedAnimation.w / cleanedAnimation.h
      : 16 / 9;

  const frameWidth = Math.round(frameHeight * ar);

  return (
    <Stack
      width="100%"
      direction="row"
      alignItems="center"
      justifyContent={
        align === "left" ? "flex-start" : align === "right" ? "flex-end" : "center"
      }
      marginTop={{ xs: -5, lg: -4 }}
      marginBottom={{ xs: 2, lg: 2 }}
    >
      <Box
        sx={{
          display: "block",
          width: frameWidth,
          height: { xs: "150px", lg: frameHeight },
          mx: "auto",
          py: framePadding,
          px: 20,
          boxSizing: "content-box",
          overflow: "hidden",
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "grid",
            placeItems: "center",
            transform: { xs: "scale(0.85)", lg: `scale(${artScale})` },
            transformOrigin: "center",
          }}
        >
          <Lottie
            animationData={cleanedAnimation}
            loop={false}
            rendererSettings={{ preserveAspectRatio: "xMidYMid meet" }}
            style={{ width: "100%", height: "100%" }}
          />
        </Box>
      </Box>
    </Stack>
  );
}